import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { WizardSteps, MultiSelect } from '../../components'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { certificates as endpoints } from '@URLS'
import { linkPaths } from '../urls'

export const Requirements = () => {
  const [state, dispatch] = useStateValue()
  const history = useHistory()

  useEffect(() => {
    if (state.chapters.chapterChoices.length > 0 && Object.keys(state.assessments).length > 0) return
    const fetchData = async () => {
      try {
        const [chaptersResp, assessmentsResp] = await Promise.all([
          client.get(endpoints.chapters()),
          client.get(endpoints.assessments()),
        ])
        dispatch({ type: 'UPDATE_CHAPTERS', payload: chaptersResp.data })
        dispatch({ type: 'UPDATE_ASSESSMENTS', payload: assessmentsResp.data })
      } catch (err) {
        console.error('Error fetching requirements data', err)
      }
    }
    fetchData()
  }, [])

  const goBack = e => {
    e.preventDefault()
    history.push(linkPaths.design)
  }

  const goNext = e => {
    e.preventDefault()
    history.push(linkPaths.review)
  }

  const handleAssessmentsChange = event => {
    if (event.target.checked) {
      dispatch({
        type: 'PUSH_ASSESSMENTS',
        payload: [...state.certInfo.selectedAssessments, event.target.value],
      })
    } else {
      const selected = [...state.certInfo.selectedAssessments]
      selected.splice(selected.indexOf(event.target.value), 1)
      dispatch({ type: 'PUSH_ASSESSMENTS', payload: selected })
    }
  }

  const handleChaptersChange = event => {
    if (event.target.checked) {
      dispatch({
        type: 'PUSH_CHAPTERS',
        payload: [...state.certInfo.selectedChapters, event.target.value],
      })
    } else {
      const selected = [...state.certInfo.selectedChapters]
      selected.splice(selected.indexOf(event.target.value), 1)
      dispatch({ type: 'PUSH_CHAPTERS', payload: selected })
    }
  }

  const scoreOptions = []
  for (let i = 1; i < 21; i++) {
    scoreOptions.push(
      <option value={i * 5} key={i * 5}>
        {i * 5}%
      </option>
    )
  }

  const needsRequirements =
    state.certInfo.selectedAssessments.length === 0 &&
    state.certInfo.selectedChapters.length === 0

  return (
    <div>
      <WizardSteps
        edit={state.certInfo.retrievedEditData}
        step={2}
        linkPaths={linkPaths}
        heading="Certificate"
        subHeading="Define Requirements"
      />
      <div className="requirements-container">
        <form>
          <MultiSelect
            label="Required Assessments: "
            onSelected={handleAssessmentsChange}
            contentArray={Object.keys(state.assessments).map(pk => ({
              name: state.assessments[pk],
              checked: state.certInfo.selectedAssessments.includes(pk) === true,
              id: pk,
            }))}
          />
          <div className="form-row">
            <div className="form-label">
              <label className="fs-xl" htmlFor="passing-score">
                Lowest Passing Score:
              </label>
            </div>
            <div className="field">
              <select
                id="passing-score"
                onChange={e =>
                  dispatch({
                    type: 'PUSH_PASSING_SCORE',
                    payload: e.target.value,
                  })
                }
                value={state.certInfo.passingScore}
                className="form-control"
              >
                {scoreOptions}
              </select>
            </div>
          </div>
          <MultiSelect
            label="Required Content: "
            onSelected={handleChaptersChange}
            contentArray={state.chapters.chapterChoices.map(obj => ({
              name: obj.title,
              checked: state.certInfo.selectedChapters.includes(obj.id) === true,
              id: obj.id,
            }))}
          />
        </form>
        <div className="btn_container">
          <Button variant="primary" onClick={goBack}>
            Back
          </Button>
          <Button
            variant="primary"
            disabled={needsRequirements}
            onClick={goNext}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
